module.exports = __webpack_public_path__ + "img/puff.d8f8be86.svg";